<template>
  <b-container id="OrdersSearchResults">
    <b-row>
      <b-col xs="12" lg="3">
        <orders-menu />
        <div class="mt-4">
          <orders-search-widget-form
            :document-number="documentNumber"
            :part-number="partNumber"
            :dealer-code="dealerCode"
            :dealer-filter="dealerCodes"
          />
        </div>
      </b-col>
      <b-col xs="12" lg="9">
        <b-row>
          <h1>{{ format(getContentItem("searchResultsHeading"), SearchKeyword) }}</h1>
        </b-row>
        <b-row>
          <order-results
            :document-number="documentNumber"
            :part-number="partNumber"
            :dealer-codes="dealerCodes"
          />
        </b-row>
        <b-row>
          <invoice-results
            :document-number="documentNumber"
            :part-number="partNumber"
            :dealer-codes="dealerCodes"
          />
        </b-row>
        <b-row>
          <backorder-results
            :document-number="documentNumber"
            :part-number="partNumber"
            :dealer-codes="dealerCodes"
          />
        </b-row>
        <b-row>
          <credit-results
            :document-number="documentNumber"
            :part-number="partNumber"
            :dealer-codes="dealerCodes"
          />
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { mapGetters } from "vuex";

  import { stringHelper } from "@/components/mixins";
  import {
    BackorderResults,
    CreditResults,
    InvoiceResults,
    OrderResults,
  } from "@/components/Orders/Search/_ResultsPartials";

  import { OrdersMenu, OrdersSearchWidgetForm } from "@/components";

  export default {
    name: "OrderSearchResults",
    components: {
      BackorderResults,
      CreditResults,
      InvoiceResults,
      OrdersMenu,
      OrderResults,
      OrdersSearchWidgetForm,
    },
    mixins: [stringHelper],
    computed: {
      ...mapGetters(["getContentItem", "user"]),
      documentNumber() {
        return this.$route.query.documentNumber || "";
      },
      partNumber() {
        return this.$route.query.partNumber || "";
      },
      dealerCode() {
        return this.$route.query.dealerCode || "";
      },
      dealerFilter() {
        const filter = this.$route.query.dealerFilter;
        // Ensure it's always an array
        if (!filter) return [];
        if (Array.isArray(filter)) return filter;
        return [filter]; // If it's a string, wrap it in an array
      },
      dealerCodes() {
        if (this.dealerCode === "ALL") {
          return this.user.DealerRange.split(",");
        } else {
          return this.dealerFilter.length > 0 ? this.dealerFilter : [this.dealerCode];
        }
      },
      SearchKeyword() {
        return this.documentNumber ? this.documentNumber : this.partNumber;
      },
    },
  };
</script>
